import React from 'react';
import Input from '../../views/InputBouncy';

export default ({
  activeField, chooseActiveField, queryModel, chooseQueryOffset,
}) => (
      <Input
        type="number"
        name="offset"
        min={0}
        max={10000}
        value={queryModel.offset}
        onChange={chooseQueryOffset}
      />
);

